import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiStringMessage } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiStringMessageDialogData {
  title?: string;
  string_messages?: ApiStringMessage[];
}

@Component({
  selector: 'app-multi-string-message-dialog',
  templateUrl: './multi-string-message-dialog.component.html',
  styleUrls: ['./multi-string-message-dialog.component.css'],
  standalone: false,
})
export class MultiStringMessageDialogComponent implements OnInit {

  title: string = '';

  // 名称×言語数
  stringMessages: ApiStringMessage[] = [];
  stringMessagesFormGroup!: FormGroup;
  stringMessagesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiStringMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiStringMessageDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.title = this.data.title!;
    if (!this.title) {
      this.title = '文字列設定';
    }
    this.stringMessages = this.data.string_messages!;
    if (!this.stringMessages) {
      this.stringMessages = [];
    }
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    this.createForm();
    this.stringMessagesArrayControl = this.stringMessagesFormGroup.get('stringMessages') as FormArray;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.stringMessagesFormGroup.disable();
    }
  }

  // 名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.stringMessages.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let string_message = '';
      let trans_string_message = '';
      for (const value of this.stringMessages) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          string_message = value.string_message;
          trans_string_message = value.trans_string_message;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          autoTrans: [auto_trans],
          stringMessage: [string_message, [Validators.required]],
          transStringMessage: [trans_string_message],
        }
      } else {
        _dict = {
          autoTrans: [auto_trans],
          stringMessage: [string_message],
          transStringMessage: [],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.stringMessagesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        stringMessages: arrayControl
      }
    );
  }

  // 更新ボタン
  addStringMessages(): void {
    if (this.stringMessagesFormGroup.valid) {
      let stringMessages = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.stringMessagesArrayControl.controls[index];
        stringMessages.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            string_message: ctrl.get('stringMessage')!.value,
            trans_string_message: ctrl.get('transStringMessage')!.value,
          }
        )
      }
      this.stringMessages = stringMessages;
      this.dialogRef.close(this.stringMessages);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // 全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.stringMessagesFormGroup.get('autoAllTrans')!.value;
    for (const stringMessage of this.stringMessagesArrayControl.controls) {
      stringMessage.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.stringMessagesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  // 言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const stringMessage of this.stringMessagesArrayControl.controls) {
      if (!stringMessage.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.stringMessagesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
